module.exports = "<form id=\"office_form\" name=\"office_form\" target=\"office_frame\" action=\"{{vm.actionUrl}}\" method=\"post\">\n\t<input name=\"access_token\" value=\"{{vm.accessToken}}\" type=\"hidden\"/>\n\t<input name=\"access_token_ttl\" value=\"{{vm.accessTokenTtl}}\" type=\"hidden\"/>\n</form>\n\n<span id=\"frameholder\"></span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/office-online/components/officeOnlineViewer/officeOnlineViewer.template.html
// module id = 1307
// module chunks = 0